import { Component, Input } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ExpenseService } from '../../services/expense.service';
import { TimesheetService } from '../../services/timesheet.service';

@Component({
    selector: 'app-time-expense-details',
    templateUrl: './time-expense-details.component.html',
    styleUrls: ['./time-expense-details.component.scss'],
    standalone: false
})
export class TimeExpenseDetailsComponent {

  public users;

  private expenses = this.expenseService.$journals;
  private times = this.timesheetService.$timesheet;

  @Input() dates: any[];
  @Input() associative: {};

  constructor(private timesheetService: TimesheetService,
              private expenseService: ExpenseService,
              private navController: NavController, ) {}

  editExpense(id) {
    const form = this.expenseService.createExpenseForm();
    this.expenseService.fillExpenseForm(form, this.expenses.value.find(elem => elem.id == id));
    this.expenseService.$editing.next(form);
    this.navController.navigateForward(['/', 'expenses', id]);
  }

  editTime(id) {
    const form = this.timesheetService.createTimeForm();
    this.timesheetService.fillTimeForm(form, this.times.value.find(elem => elem.id == id));
    this.timesheetService.$editing.next(form);
    this.navController.navigateForward(['/', 'timesheet', id]);
  }

  hasActualTimeEntry(times) {
    return times.some(entry => entry.hasOwnProperty('id'));
  }

  filterOutPublicHolidayPlaceholders(times) {
    return times.filter(entry => entry.hasOwnProperty('id'));
  }

  getIconNameByState(state) {
    switch(state) {
      case 'draft':
        return "clipboard-outline";
      case 'submitted':
        return "hourglass-outline";
      case 'denied':
        return "warning-outline";
      case 'rejected':
        return "alert-circle-outline";
      case 'approved':
        return "checkmark-outline";
      case 'paid':
        return "checkmark-done-outline";
    }            
  }
  
  getIconColorByState(state) {
    switch(state) {
      case 'draft':
        return "primary";
      case 'submitted':
        return "primary";
      case 'denied':
        return "danger";
      case 'rejected':
        return "warning";
      case 'approved':
        return "success";
      case 'paid':
        return "light";
    }            
  }

  formatHours(hoursString) {
    let timeFloat = parseFloat(hoursString);
    let hours = Math.floor(timeFloat);
    let minutes = Math.round((timeFloat - hours) * 60);
    let hoursStr = hours < 10 ? '0' + hours : '' + hours;
    let minutesStr = minutes < 10 ? '0' + minutes : '' + minutes;
    return hoursStr + ':' + minutesStr + ' h';
  }
}
